import type { TemplateId } from "../../types";
import type { FurnitureTemplate } from "./types";
import {
  armchairTemplate,
  benchTemplate,
  chairTemplate,
  ottomanTemplate,
  sectionalTemplate,
  sofaTemplate,
  stoolTemplate,
} from "./seating";
import { deskTemplate, tableTemplate } from "./tables";
import { bedTemplate, nightstandTemplate } from "./beds";
import { bookshelfTemplate, dresserTemplate, tvStandTemplate, wardrobeTemplate } from "./storage";
import { fridgeTemplate, stoveTemplate, washerTemplate } from "./appliances";
import { counterTemplate, islandTemplate } from "./countertops";
import { boxTemplate, lampTemplate, plantTemplate, rugTemplate } from "./decor";

export const TEMPLATES: Record<TemplateId, FurnitureTemplate> = {
  box: boxTemplate,
  sofa: sofaTemplate,
  sectional: sectionalTemplate,
  armchair: armchairTemplate,
  chair: chairTemplate,
  stool: stoolTemplate,
  bench: benchTemplate,
  ottoman: ottomanTemplate,
  table: tableTemplate,
  desk: deskTemplate,
  bed: bedTemplate,
  nightstand: nightstandTemplate,
  dresser: dresserTemplate,
  wardrobe: wardrobeTemplate,
  bookshelf: bookshelfTemplate,
  "tv-stand": tvStandTemplate,
  fridge: fridgeTemplate,
  washer: washerTemplate,
  stove: stoveTemplate,
  counter: counterTemplate,
  island: islandTemplate,
  rug: rugTemplate,
  lamp: lampTemplate,
  plant: plantTemplate,
};

export const TEMPLATE_IDS = Object.keys(TEMPLATES) as TemplateId[];

export function getTemplate(id: TemplateId | string | undefined): FurnitureTemplate {
  return (id && (TEMPLATES as Record<string, FurnitureTemplate>)[id]) || boxTemplate;
}

export function isTemplateId(id: unknown): id is TemplateId {
  return typeof id === "string" && id in TEMPLATES;
}

export type { FurnitureTemplate, ParamDef, BuildContext, BuildResult } from "./types";
export { resolveParams } from "./types";
